<template>
    <div class="modal fade" id="replacementHistoryModal" role="dialog" aria-labelledby="replacementHistoryModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header mt-3 mb-0">
                    <h5 class="modal-title" id="replacementHistoryModalLabel">{{$t('buttons.history.btnText')}}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <table v-if="model && Array.isArray(model)"
                           class="table table-responsive">
                        <thead>
                            <tr>
                                <th>{{ $t('dataReference.replacementHistory.id') }}</th>
                                <th>{{ $t('dataReference.replacementHistory.schemaName') }}</th>
                                <th>{{ $t('dataReference.replacementHistory.tableName') }}</th>
                                <th>{{ $t('dataReference.replacementHistory.entityId') }}</th>
                                <th>{{ $t('dataReference.replacementHistory.timestampUtc') }}</th>
                                <th />
                            </tr>
                        </thead>
                        <thead>
                        </thead>
                        <tbody>
                            <tr v-for="item in model"
                                :key="item.id">
                                <td>{{ item.id }}</td>
                                <td>{{ item.schemaName }}</td>
                                <td>{{ item.tableName }}</td>
                                <td>{{ item.entityId }}</td>
                                <td>{{ item.timestampUtc ? $moment(item.timestampUtc).format('DD.MM.YYYY HH:mm') : '' }}</td>
                                <td>
                                    <button type="button" class="btn btn-primary btn"
                                            @click.stop="onDetailsBtnClick(item.id)">
                                        {{ $t('buttons.details.btnText') }}
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                </div>
            </div>
        </div>

        <JsonFormatter v-model="replacementHistoryDetails"
            :show.sync="showReplacementHistoryDetails"
            @onClose="onReplacementHistoryDetailsClose">
        </JsonFormatter>

    </div>
</template>

<script>
    import dataReferencesService from '@/services/dataReferences.service';
    import JsonFormatter from "@/components/common/json.formatter.modal.vue";

    export default {
        components: {
            JsonFormatter
        },
        props: {
            value: {
                type: Object,
                required: false
            },
            show: {
                type: Boolean,
                default: false
            },
        },
        data() {
            return {
                model: {},
                replacementHistoryDetails: '',
                showReplacementHistoryDetails: false
            };
        },
        methods: {
            onClose() {
                this.$emit('onClose', { ...this.model });
                this.model = {};
            },
            hide() {
                $(this.$el).modal('hide');
            },
            onCancel() {
                this.onClose();
            },
            loadRankingConfirmationDeatils(inputModel) {
                return new Promise((resolve, reject) => {
                    if (!inputModel) {
                        // eslint-disable-next-line prefer-promise-reject-errors
                        reject();
                    }

                    dataReferencesService.loadReplacementHistory(inputModel.schemaName, inputModel.tableName, inputModel.entityId)
                        .then(response => {
                            resolve(response.data)
                        })
                        .catch(error => {
                            reject(error)
                        });
                });
            },
            onReplacementHistoryDetailsClose() {
                this.replacementHistoryDetails = '';
                this.showReplacementHistoryDetails = false;
            },
            onDetailsBtnClick(id) {
                dataReferencesService
                    .loadReplacementDetails(id)
                    .then(response => {
                        if (response.data) {
                            this.replacementHistoryDetails = response.data;
                        }

                        this.showReplacementHistoryDetails = true;
                    })
                    .catch(error => {
                        console.log(error);
                    });
            }
        },
        mounted() {
            // add modal close listener
            $(this.$el).on('hidden.bs.modal', this.onClose);
        },
        beforeDestroy() {
            // remove listener
            $(this.$el).off('hidden.bs.modal');
        },
        watch: {
            show: function (val) {
                if (val) {
                    this.loadRankingConfirmationDeatils(this.value)
                        .then(data => {
                            this.model = data;
                        }).catch(error => {
                            // skip
                        });
                    $(this.$el).modal('show');
                } else {
                    $(this.$el).modal('hide');
                }
            }
        }
    };
</script>

<style lang="scss" scoped>
    .bmd-form-group {
        padding-top: 0px !important;
    }
</style>
